import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { useOpenModal } from 'featureSliced/shared/hooks/useOpenModal'
import { LanguageList } from './LanguageListComponent'
import { getLanguage } from './languageList'

import { ReactComponent as WorldIcon } from 'assets/world.svg'
import { IconFilled } from 'components/IconsContainers/styled'
import { SelectedLanguageDisplay } from './styled'

export const LanguageSelector = () => {
  const mainColor = useMySelector((state) => state.app.interfaceStyles.colour)
  const selectedLanguage = useMySelector(
    (state) => state.common.selectedLanguage
  )
  const openModal = useOpenModal()
  const t = useTranslations()

  const openLanguageModal = () => {
    openModal({
      id: 'LANG_MODAL',
      title: t('common.selectLanguage'),
      components: [
        ({ closeThisModal }) => (
          <LanguageList closeThisModal={closeThisModal} />
        ),
      ],
    })
  }

  return (
    <SelectedLanguageDisplay onClick={openLanguageModal}>
      <IconFilled color={mainColor}>
        <WorldIcon />
      </IconFilled>
      <p>{getLanguage(selectedLanguage)?.name}</p>
    </SelectedLanguageDisplay>
  )
}
